var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisibleOutlineicon = function SvgVisibleOutlineicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.99 7.76a8.51 8.51 0 0 0-8-5.36A8.51 8.51 0 0 0 .06 7.74.8.8 0 0 0 0 8c0 .09.02.17.05.25A8.51 8.51 0 0 0 8 13.6c3.49.02 6.64-2.1 7.94-5.34A.65.65 0 0 0 16 8a.75.75 0 0 0 0-.24Zm-8 4.24a7.05 7.05 0 0 1-6.33-4 7.03 7.03 0 0 1 12.68 0A7.05 7.05 0 0 1 8 12ZM5.6 8a2.4 2.4 0 1 1 4.8 0 2.4 2.4 0 0 1-4.8 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgVisibleOutlineicon;